import React, { useState, useEffect } from 'react';
import Card from 'react-bootstrap/Card';
import InputGroup from 'react-bootstrap/InputGroup';
import EnterprisePicEditor from './EnterprisePicEditor';
import defaultPic from '../Images/BitBlue-Person-Default-Profile-Picture.png';
import API from '../../utils/API/enterpriseAPI';
import FloatingLabelInput from '../Custom/FloatingLabelInput';
import FloatingLabelTextarea from '../Custom/FloatingLabelTextarea';
import PhoneInput, { formatPhoneNumberIntl } from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import './EnterpriseSettings.css';

export default function EnterpriseSettings(props) {
    const { userObj, vcardObj, setVcardObj, entObj, route } = props;
    const { permissions } = userObj;

    const [view, setView] = useState('form');
    const [name_first, setFirstName] = useState(entObj?.name_first || '');
    const [name_last, setLastName] = useState(entObj?.name_last || '');
    const [phone_number, setPhoneNumber] = useState(entObj?.phone_number || '');
    const [email, setEmail] = useState(entObj?.email || '');
    const [bio, setBio] = useState(entObj?.bio || '');
    const [job_title, setTitle] = useState(entObj?.job_title || '');
    const [scheduling, setSchedule] = useState(entObj?.scheduling || '');
    const [message, setMessage] = useState(null);

    const handleSave = async () => {
        const vcard = {};
        const obj = {};

        if (email !== entObj?.email) {
            obj.email = email;
            entObj.email = email;
        };

        if (phone_number !== entObj?.phone_number) {
            obj.phone_number = formatPhoneNumberIntl(phone_number);
            entObj.phone_number = formatPhoneNumberIntl(phone_number);
        };

        if (name_first !== entObj?.name_first) {
            obj.name_first = name_first;
            vcard.name_first = name_first;
            entObj.name_first = name_first;
        };

        if (name_last !== entObj?.name_last) {
            obj.name_last = name_last;
            vcard.name_last = name_last;
            entObj.name_last = name_last;
        };

        if (bio !== entObj?.bio) {
            obj.bio = bio;
            vcard.bio = bio;
            entObj.bio = bio;
        };

        if (job_title !== entObj?.job_title) {
            obj.job_title = job_title;
            vcard.job_title = job_title;
            entObj.job_title = job_title;
        };

        if (scheduling !== entObj?.scheduling) {
            if (scheduling) {
                vcard['scheduling/calendly_url'] = scheduling;
            } else {
                vcard['scheduling/calendly_url'] = '';
                vcard['scheduling/enabled'] = false;
            };
            obj.scheduling = scheduling;
            entObj.scheduling = scheduling;
        };

        if (Object.keys(vcard).length > 0) {
            try {
                await API.updateEnterpriseVcardByUID(userObj.uid, vcard);
            } catch (e) {
                console.log(e);
            };
        };

        if (Object.keys(obj)?.length > 0) {
            try {
                await API.updateEnterpriseAccount(userObj?.uid, obj);
                setMessage({ message: 'Success!', success: true });
            } catch (e) {
                setMessage({ message: 'Error updating account.', success: false });
            };
        };
    };

    useEffect(() => {
        if (message) {
            setTimeout(() => {
                setMessage(null);
            }, 3000);
        };
    }, [message]);

    return (
        <Card className='enterprise-settings-card'>
            <Card.Header>User Information</Card.Header>
            <Card.Body>
                {view === 'profile-pic-edit' ?
                    <EnterprisePicEditor setView={setView} setVcardObj={setVcardObj} profile_pic={vcardObj.profile_pic} route={route} uid={userObj.uid} />
                :
                    <>
                    <div className='enterprise-settings-pic-wrapper'>
                        <div className='enterprise-settings-pic-container' onClick={() => setView('profile-pic-edit')} style={!permissions.edit_profile_pic ? { pointerEvents: 'none' } : { pointerEvents: 'all' }}>
                            <img src={vcardObj?.profile_pic ? `${vcardObj.profile_pic}?${Date.now()}` : defaultPic} alt='settings profile-pic' height='100%' width='100%' />
                            <div className='enterprise-settings-pic-edit'>Edit</div>
                        </div>
                    </div>
                    <InputGroup>
                        <FloatingLabelInput state={name_first} setState={setFirstName} type='text' id='first-name' label='First Name' style={{ borderRadius: '2.5rem' }} disabled={!permissions.edit_name} />
                    </InputGroup>
                    <InputGroup>
                        <FloatingLabelInput state={name_last} setState={setLastName} type='text' id='last-name' label='Last Name' style={{ borderRadius: '2.5rem' }} disabled={!permissions.edit_name} />
                    </InputGroup>
                    <InputGroup className='mb-3'>
                        <label className='mb-0 phone-label button-type-float' htmlFor='add-button-phone'>Phone Number</label>
                        <PhoneInput
                            id='add-button-phone'
                            international
                            className='enterprise-add-phone-input'
                            countryCallingCodeEditable={false}
                            placeholder='Enter phone number.'
                            defaultCountry='US'
                            value={phone_number.replaceAll(' ','')}
                            onChange={setPhoneNumber}
                            disabled={!permissions.edit_phone_number}
                        />
                    </InputGroup>
                    <InputGroup>
                        <FloatingLabelInput state={email} setState={setEmail} type='email' id='email' label='Email' style={{ borderRadius: '2.5rem' }} disabled={!permissions.edit_email} />
                    </InputGroup>
                    <InputGroup>
                        <FloatingLabelTextarea state={bio} setState={setBio} id='bio' label='Bio' style={{ borderRadius: '1rem 1rem 1.5rem' }} disabled={!permissions.edit_bio} />
                    </InputGroup>
                    <InputGroup>
                        <FloatingLabelInput state={job_title} setState={setTitle} type='text' id='job-title' label='Job Title' style={{ borderRadius: '2.5rem' }} disabled={!permissions.edit_job_title} />
                    </InputGroup>
                    <InputGroup>
                        <FloatingLabelInput state={scheduling} setState={setSchedule} type='url' id='scheduling' label='Schedule Link' style={{ borderRadius: '2.5rem' }} disabled={!permissions.scheduling} />
                    </InputGroup>
                    <button className='enterprise-settings-btn' onClick={handleSave}>Save</button>
                    {message ? <div className='enterprise-settings-message' style={message?.success ? { color: 'green' } : { color: 'red' }}>{message?.message}</div> : <></>}
                    </>
                }
            </Card.Body>
        </Card>
    );
};